import React,{useEffect,useState} from "react";
import AddButtonSection from '../../../components/common/AddButtonSection';
import PatientListReport from "./PatientList.jsx"
import ResourceListReport from "./ResourceList.jsx"
import ProfileView from '../../../components/common/profileView';
import {convertToNameLabel} from "../../../utils/utils";
import { commonPostApi,commonGetApi } from "../../../utils/apiService";
import { API_ENDPOINTS } from "../../../utils/apiEndpoints";
import { useSelector } from "react-redux";
const CampManagerReport = () => {
  const id = useSelector(state=> state.common.camp?.camp_details_id)
  const [camp,setCamp]= useState({});
  const [purpose,setPurpose]= useState([]);
  const [profileLoading, setProfileLoading] = useState(false);
  const [tab,setTab]= useState("Patient");
  const [roleDetails, setRoleDetails] = useState([]);
  const AddUserbuttons = [
    {
      type: tab === "Patient" ? "primarySuccessButton" : "inActiveButton",
      label: "Patients",
      class: "md:col-1 ml-3 my-2 ",
      onClick: () => setTab("Patient")
    },
    {
      type: tab === "Resources" ? "primarySuccessButton" : "inActiveButton",
      label: "Resources",
      class: "md:col-1 my-2 ",
      onClick: () => setTab("Resources")
    },
  ];

  useEffect(() => {
    init();
  }, [id]);

  const init = async () => {
    if (!id) {
      setProfileLoading(false);
      return;
    }
    setProfileLoading(true);
    Promise.all([
      await commonPostApi(API_ENDPOINTS.SEARCH_CAMP_DETAILS, {
        camp_details_id: id,
      }),
      await commonPostApi(API_ENDPOINTS.SEARCH_LOOKUP_DETAILS, {
        lookup_type_name: "VISIT_PURPOSE",
      }),
      await commonPostApi(API_ENDPOINTS.GET_ALL_ROLES,{camp_details_id: id}),
    ])
    .then(async ([ campInfo = {},lookupdetails = [],role]) => {
      setPurpose(lookupdetails?.data?.data);
      setRoleDetails(role?.data?.data);
      const campDetails = campInfo?.data?.data;
      const finalList = {};
      const keyMapping = {
          camp_code: "camp_iD",
          camp_type_name: "type",
          state: "location",
          frequency_name:"frequency"
      };
      [
        "camp_code",
        "start_date",
        "end_date",
        "camp_type_name",
        "frequency_name",
        "state",
      ].forEach((item) => {
          finalList[keyMapping[item] || item] = campDetails[item];
      });
      let finalData = convertToNameLabel(finalList, [
          "camp_name",
          "camp_details_id",
          "description",
          "organization_id",
          "created_at",
          "updated_at",
          "created_by",
          "updated_by",
          "address",
          "city",
          "district",
          "pincode",
          "contact_name",
          "contact_number"
      ]);
      finalData.name = campDetails["camp_name"];
      setCamp(finalData);
      setProfileLoading(false);
    })
    .catch((err) => {
      console.log(err);
    });
  };

  return (
    <>
      <ProfileView
        profile={camp}
        loading={profileLoading}
        parentClass={"ml-auto"}
      />
      <AddButtonSection buttons={AddUserbuttons} />
      {tab === "Patient" && <PatientListReport purpose={purpose}/>}
      {tab === "Resources" && <ResourceListReport role={roleDetails}/>}
    </>
  );
};

export default CampManagerReport;